import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightning = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.68182 1.5L8.31818 6.95455H16.5L8.31818 16.5L9.68182 11.0455H1.5L9.68182 1.5Z",
		stroke: "#282E9A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLightning;
